module.exports = __webpack_public_path__ + "img/img1.fb3275ec.png";